import { useEffect, useState } from 'react';
import { api } from '../lib/api';

// Conteúdo editável do site (vídeo do "Como funciona"), vindo do admin. Uma busca por visita.
let request = null;

export default function useSiteSettings() {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    let off = false;
    request ||= api.get('/site-settings').then(({ data }) => data).catch(() => null);
    request.then((d) => { if (!off) setSettings(d); });
    return () => { off = true; };
  }, []);
  return settings;
}
